import api from '../api/axios';

export interface SystemLog {
  id: number;
  attributes?: {
    action: string;
    entity: string;
    entityId?: number;
    description: string;
    user?: any;
    changes?: any;
    ipAddress?: string;
    userAgent?: string;
    severity: 'info' | 'warning' | 'error' | 'critical';
    createdAt: string;
    updatedAt: string;
  };
  action?: string;
  entity?: string;
  entityId?: number;
  description?: string;
  user?: any;
  changes?: any;
  ipAddress?: string;
  userAgent?: string;
  severity?: 'info' | 'warning' | 'error' | 'critical';
  createdAt?: string;
  updatedAt?: string;
}

export const systemLogService = {
  async getAll(params?: any) {
    const response = await api.get('/system-logs', {
      params: {
        populate: ['user'],
        sort: 'createdAt:desc',
        'pagination[pageSize]': 100,
        ...params
      }
    });
    return response.data;
  },

  async getById(id: number) {
    const response = await api.get(`/system-logs/${id}`, {
      params: { populate: ['user'] }
    });
    return response.data;
  },

  async create(data: Partial<SystemLog>) {
    const response = await api.post('/system-logs', { data });
    return response.data;
  },

  async createLog(action: string, entity: string, description: string, changes?: any, entityId?: number) {
    return this.create({
      action,
      entity,
      entityId,
      description,
      changes,
      severity: 'info'
    });
  }
};

